import { render, staticRenderFns } from "./BOrderList.vue?vue&type=template&id=4ae4edd2&scoped=true"
import script from "./BOrderList.vue?vue&type=script&lang=ts"
export * from "./BOrderList.vue?vue&type=script&lang=ts"
import style0 from "./BOrderList.vue?vue&type=style&index=0&id=4ae4edd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4edd2",
  null
  
)

export default component.exports